(function () {
  'use strict';

  function forEachNode(nodes, callback) {
    Array.prototype.forEach.call(nodes, callback);
  }

  function formatWeight(weight) {
    var numericWeight = Number(weight);
    if (!isFinite(numericWeight) || numericWeight <= 0) return '';
    return numericWeight.toLocaleString('en-US', { maximumFractionDigits: 1 });
  }

  function findMatchingVariant(variants, candidateOptions) {
    for (var variantIndex = 0; variantIndex < variants.length; variantIndex += 1) {
      var variant = variants[variantIndex];
      if (!Array.isArray(variant.options) || variant.options.length !== candidateOptions.length) continue;

      var matches = true;
      for (var optionIndex = 0; optionIndex < variant.options.length; optionIndex += 1) {
        if (variant.options[optionIndex] !== candidateOptions[optionIndex]) {
          matches = false;
          break;
        }
      }

      if (matches) return variant;
    }

    return null;
  }

  function initializeGroup(lengthField) {
    if (lengthField.getAttribute('data-gz-length-weights-ready') === 'true') return;

    var root = lengthField.closest('[data-section-product-main]');
    if (!root) return;

    var product;
    try {
      product = JSON.parse(root.getAttribute('data-product-json'));
    } catch (error) {
      return;
    }

    if (!product || !Array.isArray(product.variants)) return;

    var lengthOptionIndex = Number(lengthField.getAttribute('data-gz-length-option-index'));
    var weightUnit = lengthField.getAttribute('data-gz-weight-unit') || 'g';
    var visualUnit = weightUnit.toUpperCase();
    var spokenUnit = weightUnit.toLowerCase() === 'g' ? 'grams' : weightUnit;
    var tiles = lengthField.querySelectorAll('[data-gz-length-value]');

    function selectedOptions() {
      var values = [];
      forEachNode(root.querySelectorAll('[data-product-swatch]'), function (field) {
        var optionIndex = Number(field.getAttribute('data-product-swatch'));
        var checked = field.querySelector('[data-product-swatch-input]:checked');
        values[optionIndex] = checked ? checked.value : null;
      });
      return values;
    }

    function updateLengthWeights() {
      var baseOptions = selectedOptions();

      forEachNode(tiles, function (tile) {
        var measure = tile.querySelector('[data-gz-length-weight]');
        if (!measure) return;

        var candidateOptions = baseOptions.slice();
        candidateOptions[lengthOptionIndex] = tile.getAttribute('data-gz-length-value');

        var matchingVariant = findMatchingVariant(product.variants, candidateOptions);
        var formattedWeight = matchingVariant ? formatWeight(matchingVariant.weight) : '';

        if (!formattedWeight) {
          measure.hidden = true;
          measure.textContent = '';
          measure.removeAttribute('aria-label');
          return;
        }

        measure.hidden = false;
        measure.textContent = '≈ ' + formattedWeight + ' ' + visualUnit;
        measure.setAttribute('aria-label', 'Approximate weight ' + formattedWeight + ' ' + spokenUnit);
      });
    }

    lengthField.setAttribute('data-gz-length-weights-ready', 'true');
    updateLengthWeights();

    root.addEventListener('change', function (event) {
      if (!event.target || !event.target.matches('[data-product-swatch-input]')) return;
      window.requestAnimationFrame(updateLengthWeights);
    });
  }

  function initialize(scope) {
    var searchRoot = scope && scope.querySelectorAll ? scope : document;
    forEachNode(searchRoot.querySelectorAll('[data-gz-length-option-index]'), initializeGroup);
  }

  if (window.__gzVariantWeightsLoaded) {
    initialize(document);
    return;
  }

  window.__gzVariantWeightsLoaded = true;
  initialize(document);
  document.addEventListener('shopify:section:load', function (event) {
    initialize(event.target);
  });
})();
